export class EmployeeCertification {
    id = 0;

    effectiveDate = null;

    expirationDate = null;

    certificationId = 0;

    employeeId = 0;
}
